import BaseApiClient from '../BaseApiClient';

export interface FcaFirm {
  fca_number: string;
  name: string;
  status: string;
}

/** FCA register firm search. Lives on the general CRM API, so it sends no Version header. */
export class ApiFca extends BaseApiClient {
  async search(name: string): Promise<FcaFirm[]> {
    const res = await this.client.get('/fca-search', { params: { name } });
    const firms = res.data?.firms;

    return Array.isArray(firms) ? firms : [];
  }
}
